import P3Regular from 'components/typography/P3Regular';
import { PriceOfferRow } from 'components/tables/data/price-offer/types';

/**
 * Column for the price offer id.
 */
export default function PriceOfferIdColumn({ data }: { data: PriceOfferRow }) {
  return <P3Regular color="gray.8">{data.priceOfferId}</P3Regular>;
}
